module.exports = __webpack_public_path__ + "media/images/career_camp/2023/areas_2-b794180478e2ad4b45690c16069db1b7.png";